import { ComponentProps } from 'react';
import { zIndexReference } from 'shared/styling';
import { Box } from 'shared/Typhography/Box';
import { Image } from 'shared/Typhography/Image';
import { Text } from 'shared/Typhography/Text';
import styled from 'styled-components';
import { theme } from 'theme';

import { useContentPreviewScreenLogic } from './hooks/useContentPreviewScreenLogic';

const ImageContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${zIndexReference.WhateverNeedsToBeOnTopOfEverything};
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: white; /* Makes sure transparent parts of checkered background are not visible */

  /* Checkered background */
  background-image: linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(135deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(135deg, transparent 75%, #ccc 75%);
  background-size: 25px 25px; /* Must be a square */
  background-position: 0 0, 12.5px 0, 12.5px -12.5px, 0px 12.5px; /* Must be half of one side of the square */
`;

const imageStyles: ComponentProps<typeof Image>['style'] = {
  width: 'auto',
  height: '100%',
  aspectRatio: '1',
  objectFit: 'contain',
  imageRendering: 'pixelated',
};

/**
 * Screen for previewing content's image/video in large view.
 */
export const ContentPreviewScreen = () => {
  const { contentType, contentUrl } = useContentPreviewScreenLogic();

  if (!contentType || !contentUrl) {
    return (
      <Box margin="150px auto">
        {!contentType && <Text color={theme.colors.red}>Content type is missing.</Text>}
        {!contentUrl && <Text color={theme.colors.red}>Content URL is missing.</Text>}
      </Box>
    );
  }

  return (
    <ImageContainer>
      {contentType === 'coloringGrid' && <Image src={contentUrl} style={imageStyles} />}
    </ImageContainer>
  );
};
